/** Locale date-time (with time-of-day). Returns "—" for empty, echoes raw on parse failure. */
export const formatDateTime = (value: string | null): string => {
  if (!value) return "—"
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString()
}

/** Locale date only (no time-of-day). Returns "—" for empty, echoes raw on parse failure. */
export const formatDay = (value: string | null): string => {
  if (!value) return "—"
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString()
}
